import { SiteCodeGroupEnum } from '@abg/shared';

import { LocationSuggestionOption } from '../../location-search.types';

const formatPresentValue = (
  value: string | null | undefined,
  isFirst = false,
) => {
  return value?.trim().length ? `${isFirst ? '' : ', '}${value}` : '';
};

export const getLocationSubtitle = (
  location: LocationSuggestionOption,
  multipleLocationsLabel?: string,
) => {
  if (location.suggestionTypeCode === 'CURRENT') {
    return '';
  }

  // different formatting for airports
  if (location.siteCodeGroup === ('AIRPORT' as SiteCodeGroupEnum)) {
    return `${formatPresentValue(location.cityName, true)}${formatPresentValue(location.countryName)}`;
  }

  const subTitle =
    location.typeCode === 'Other'
      ? (multipleLocationsLabel ?? '')
      : `${formatPresentValue(location.addressLine1, true)}${formatPresentValue(location.addressLine2)}${formatPresentValue(location.cityName)}${formatPresentValue(location.countryName)}`;

  return subTitle;
};
